/* Desktop controls use the theme's native gallery, including variant selection. */
function ccDesktopGallery(root = document) {
  root.querySelectorAll('media-gallery').forEach(gallery => {
    if (gallery.querySelector('.cc-desktop-gallery-controls')) return;
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (!viewer || !gallery.querySelector('[id^="GalleryThumbnails-"]')) return;
    const controls = document.createElement('div');
    controls.className = 'cc-desktop-gallery-controls';
    const en = document.documentElement.lang.startsWith('en');
    [-1, 1].forEach(direction => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = direction < 0 ? '←' : '→';
      button.setAttribute('aria-label', en ? (direction < 0 ? 'Previous image' : 'Next image') : (direction < 0 ? 'Image précédente' : 'Image suivante'));
      button.addEventListener('click', () => {
        const items = [...viewer.querySelectorAll('.product__media-item[data-media-id]')];
        const index = Math.max(0, items.findIndex(item => item.classList.contains('is-active')));
        const next = items[(index + direction + items.length) % items.length];
        if (next && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(next.dataset.mediaId, false);
      });
      controls.append(button);
    });
    viewer.append(controls);
  });
}
ccDesktopGallery();
document.addEventListener('shopify:section:load', event => ccDesktopGallery(event.target));
